import React from 'react';

import ApiEndPoints from '../../constants/endpoints';

import authenticationMixin from '../../mixins/authenticationMixin';

// Every signed-in user can download their own data, whatever their plan. The API checks the
// sign-in token, not the subscriber-only download token that PowerPoint downloads use.
class AccountDownloadLink extends React.Component {
  constructor() {
    super();
    this.submit = this.submit.bind(this);
  }

  // a plain form post, so the browser saves the zip the API sends back
  submit() {
    const { userApiRequest } = this.props;
    const form = document.createElement('form');
    form.method = 'post';
    form.action = ApiEndPoints.DOWNLOADACCOUNT;

    [['x-user-token', userApiRequest['X-USER-TOKEN']], ['x-user-email', userApiRequest['X-USER-EMAIL']]].forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    // removing the form in the same tick cancels the submission, so wait for it to start
    setTimeout(() => form.remove(), 1000);
  }

  render() {
    return <button type="button" className="download-link" onClick={this.submit}>Download my data</button>;
  }
}

export default authenticationMixin(AccountDownloadLink);
